module.exports = __webpack_public_path__ + "img/ico_menual05_off.e51615f5.svg";